module.exports = __webpack_public_path__ + "static/media/logo_svg.24ed946f.svg";